import { gql } from "@apollo/client";
import { Account, accountFragment, UserProfile, userProfileFragment } from "common/graphql";

export const GET_USER_PROFILE = gql`
  query GetUserProfile($userId: uuid!, $activeAccountId: uuid!, $hasActiveAccountId: Boolean!) {
    userProfile: auth_user_profile_by_pk(id: $userId) {
      ...userProfileFragment
    }
    activeAccount: account_by_pk(id: $activeAccountId) @include(if: $hasActiveAccountId) {
      ...accountFragment
    }
    activeFeatureFlag: active_feature_flag {
      id
      key
      enabled
    }
  }
  ${userProfileFragment}
  ${accountFragment}
`;

export interface ActiveFeatureFlag {
  id: string;
  key: string;
  enabled: boolean;
}

export interface GetUserProfileData {
  userProfile: UserProfile;
  /**
   * Populated only when `$hasActiveAccountId` is true. When the caller provides
   * no `activeAccountId`, this field is omitted via `@include` and the
   * `useUserProfile` hook falls back to `userProfile.account`.
   */
  activeAccount?: Account | null;
  activeFeatureFlag: ActiveFeatureFlag[];
}

export interface GetUserProfileVars {
  userId: string;
  /**
   * Optional. When set, the query fetches the full `account` row for this id
   * and the `useUserProfile` hook overwrites `userProfile.account` with it so
   * existing consumers automatically see the active operational context.
   */
  activeAccountId?: string;
  hasActiveAccountId?: boolean;
}

export default GET_USER_PROFILE;
